import { Box } from "@mui/material";

type SubBodyType = {
  menus: any[];
  onClickSub: (e?: any, item?: any) => void;
};

export default function SubBody({ menus, onClickSub }: SubBodyType) {
  return (
    <Box className="parent-nav-sub">
      <Box
        sx={{
          height: `${
            menus && menus.length > 10
              ? `calc(${menus.length} * 90px)`
              : "100vh"
          }`,
        }}
        className="nav-sub"
      >
        {menus &&
          menus.map((item: any, index: number) => {
            return (
              <Box
                onClick={(e: any) => {
                  onClickSub(e, item);
                }}
                className="sub-item"
                key={index}
              >
                <p className="text-label">{item.label}</p>
              </Box>
            );
          })}
      </Box>
    </Box>
  );
}
